import { Subject } from "rxjs";
import { filter } from "rxjs/operators";
import { observable } from "mobx";

export class Application implements Common.IApplication {
  eventBus: Subject<Common.IAppEvent>;
  servicesFactories: Common.IDictionary<Common.ServiceFactory>;
  services: Common.IDictionary<any>;
  @observable.ref features: Common.IAppFeature[] = [];

  constructor() {
    this.eventBus = new Subject<Common.IAppEvent>();
    this.servicesFactories = {};

    this.services = {};
  }

  registerFeature(feature: Common.IAppFeature) {
    this.features = [...this.features, feature];
  }

  on<TData = any>(eventType: string, callback: Common.Callback<TData>): Common.CleanupFn {
    const subscription = this.eventBus
      .pipe(filter(evt => evt.type === eventType))
      .subscribe(callback);

    return () => subscription.unsubscribe();
  }

  emit<TData = any>(eventType: string, data: TData): void {
    this.eventBus.next({
      type: eventType,
      data
    });
  }

  registerService<TService>(
    key: string,
    factory: Common.ServiceFactory<TService>
  ): Common.IApplication {
    if (this.services[key]) {
      throw new Error(`A service instance with the same key is already instantiated: ${key}`);
    }

    if (this.servicesFactories[key]) {
      throw new Error(`A service with the same key is already registered: ${key}`);
    }

    this.servicesFactories[key] = factory;

    return this;
  }

  isServiceRegistered(key: string): boolean {
    return !!(this.services[key] || this.servicesFactories[key]);
  }

  getService<TService>(key: string): TService {
    if (this.services[key]) {
      return this.services[key];
    }
    if (!this.servicesFactories[key]) {
      throw new Error(`No service with the provided key can be found: ${key}`);
    }

    this.services[key] = this.servicesFactories[key](this);

    return this.services[key];
  }

  unregisterService(key: string): Common.IApplication {
    if (this.services[key]) {
      delete this.services[key];
    }

    if (this.servicesFactories[key]) {
      delete this.servicesFactories[key];
    }

    return this;
  }
}
